export const featureConstraints: { [key: string]: FeatureConstraints } = {
  isCC: {
    CbUnsupported: true
  },
  isCB: {
    CcUnsupported: true
  },
  test: {
    fromCbVersion: '2.0.1254',
    toCbVersion: '3.1.1290',
    fromAndroidVersion: '7.0',
    toAndroidVersion: '8.0',
    fromCcVersion: '20.0.0.0',
    toCcVersion: '20.0.0.3163',
    fromWindowsVersion: '10.0',
    toWindowsVersion: '10.0'
  },
  CbTest: {
    fromCbVersion: '3.1.1000'
  },
  WinSecurity: {
    CbUnsupported: true
  },
  WinUsers: {
    CbUnsupported: true,
    fromCcVersion: '21.0.0.3205'
  },
  GPS : {
    CcUnsupported: true,
    ChromeOSUnsupported: true
  },
  AndroidSecurity: {
    CcUnsupported: true
  },
  Screenshots: {
    fromCbVersion: '3.1.1265',
    toAndroidVersion: '10',
    CbUnsupported: false,
    CcUnsupported: false,
    ChromeOSUnsupported: true
  },
  ScreenshotsV2: {
    fromCbVersion: '3.1.1386',
    CcUnsupported: true,
    ChromeOSUnsupported: true
  },
  NoAppsInBlockTime: {
    fromCbVersion: '3.1.1181',
    fromCcVersion: '22.0.0.3224'
  },
  protectSettings: {
    fromCbVersion: '3.1.1159'
  },
  cb3background: {
    fromCbVersion: '3.1.1159'
  },
  onesecinterval: {
    fromCbVersion: '3.1.1181'
  },
  roamingv2: {
    fromCbVersion: '3.1.1200'
  },
  loginlock: {
    fromCbVersion: '3.1.1209'
  },
  crackProtection: {
    fromCbVersion: '3.1.1228',
    toCbVersion: '3.1.1329'
  },
  bonus: {
    fromCbVersion: '3.1.1228'
  },
  addBonusTAN: {
    fromCbVersion: '3.1.1228'
  },
  bonusMax: {
    fromCbVersion: '3.1.1236',
    fromCcVersion: '21.0.0.3200'
  },
  noDeleteExtension: {
    fromCbVersion: '3.1.1241'
  },
  permissionButton: {
    fromCbVersion: '3.1.1251'
  },
  noBonusNotification: {
    fromCbVersion: '3.1.1254'
  },
  pause: {
    fromCbVersion: '3.1.1261'
  },
  screenshot: {
    fromCbVersion: '3.1.1265'
  },
  noBlockNotification: {
    fromCbVersion: '3.1.1273'
  },
  misc20201: {
    fromCbVersion: '3.1.1276'
  },
  noBlockDualScreen: {
    fromCbVersion: '3.1.9999'
  },
  dayChart: {
    fromCbVersion: '3.1.1285'
  },
  alwaysBlockNotification: {
    fromCbVersion: '3.1.1289'
  },
  noAudioStop: {
    fromCbVersion: '3.1.1291'
  },
  disablePopup: {
    fromCbVersion: '3.1.1291'
  },
  alwaysAllowedWeb: {
    fromCbVersion: '3.1.1301'
  },
  hasWebGroups: {
    fromCbVersion: '3.1.9999',
    fromCcVersion: '99.0.0.9999',
  },
  generalBeepValue: {
    fromCcVersion: '21.0.0.3184'
  },
  checkUrlFallBack: {
    fromCcVersion: '21.0.0.3184'
  },
  customBlockMsg: {
    fromCcVersion: '20.0.0.3171',
    fromCbVersion: '3.1.1295'
  },
  compatibilityMode: {
    fromCcVersion: '21.0.0.3188'
  },
  noExtensionDeleteAuto: {
    fromCbVersion: '3.1.1313'
  },
  warnAsToast: {
    fromCbVersion: '3.1.1368',
    CcUnsupported: true
  },
  websiteGroups: {
    fromCbVersion: '3.1.1317',
    fromCcVersion: '22.0.0.3207'
  },
  overrideSettings: {
    fromCbVersion: '3.1.1318',
    CcUnsupported: true
  },
  webfilter: {
    CcUnsupported: false,
    CbUnsupported: false,
    ChromeOSUnsupported: true
  },
  alwaysPlusBlocktimes: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1330',
  },
  manipulationDuration: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1330'
  },
  notificationBlockLevel: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1335'
  },
  noAllowedPlusInPause: {
    CbUnsupported: true,
    fromCcVersion: '22.0.0.3222'
  },
  keywordsSearchOnly: {
    CbUnsupported: true,
    fromCcVersion: '22.0.0.3232'
  },
  totalLocalTime: {
    fromCcVersion: '22.0.0.3223',
    fromCbVersion: '3.1.1337'
  },
  missingNotificationRight: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1344'
  },
  ccStandardIcon: {
    CbUnsupported: true,
    fromCcVersion: '22.0.0.3234'
  },
  fixPortraitBlock: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1347',
    toCbVersion: '3.1.1409'
  },
  bonusPosition: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1347'
  },
  manualTimes: {
    fromCcVersion: '99.0.0.9999',
    fromCbVersion: '3.1.9999'
  },
  notificationAccess: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1348'
  },
  audioOverride: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1361'
  },
  timecountv2: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1364'
  },
  hasSamsec: {
    CcUnsupported: true,
    fromCbVersion: '3.1.1363'
  },
  hideViewLimitsReports: {
    fromCbVersion: '3.1.1372',
    fromCcVersion: '23.0.0.3296'
  },
  countAlwaysExe: {
    fromCcVersion: '23.0.0.3296',
    CbUnsupported: true
  },
  extensionRequest: {
    fromCbVersion: '3.1.1375',
    fromCcVersion: '23.0.0.3302'
  },
  samsecMultiUser: {
    fromCbVersion: '3.1.1375',
    CcUnsupported: true,
  },
  hidePasswordForgotten: {
    fromCbVersion: '3.1.1380',
    CcUnsupported: true,
  },
  webFilterAllApps: {
    fromCcVersion: '23.0.0.3321',
    CbUnsupported: true
  },
  remainingInfoDetails: {
    fromCbVersion: '3.1.1381',
    fromCcVersion: '23.0.0.3328'
  },
  disableSplitAndCb3Counting: {
    fromCbVersion: '3.1.1384',
    CcUnsupported: true
  },
  hideUnblockRequest: {
    fromCbVersion: '3.1.1388',
    CcUnsupported: true
  },
  sameSecPinApp: {
    fromCbVersion: '3.1.1391',
    CcUnsupported: true
  },
  appCheckLevel: {
    fromCbVersion: '3.1.1392',
    CcUnsupported: true
  },
  skipTotalBySpecialApps: {
    fromCbVersion: '3.1.1397',
    CcUnsupported: true
  },
  tanOffline: {
    fromCbVersion: '3.1.1398',
    CcUnsupported: true
  },
  webfilterLevel: {
    fromCbVersion: '3.1.1404',
    fromCcVersion: '24.0.0.3356'
  },
  noAllowedPlusInPauseCB: {
    fromCbVersion: '3.1.1407',
    CcUnsupported: true
  },
  playRingtone: {
    fromCbVersion: '3.1.1410',
    CcUnsupported: true
  },
  samsecDisableApps: {
    fromCbVersion: '3.1.1428',
    CcUnsupported: true
  },
  blockExtensionApp: {
    fromCbVersion: '3.1.1431',
    CcUnsupported: true
  },
  androidSoundLimit: {
    fromCbVersion: '3.1.1433',
    CcUnsupported: true
  },
  blockExtensionAppCC: {
    CbUnsupported: true,
    fromCcVersion: '25.0.0.3366'
  },
  noAudioStopV2: {
    fromCbVersion: '3.1.1435',
    CcUnsupported: true
  },
  webSafeSearch: {
    CbUnsupported: true,
    fromCcVersion: '25.0.0.3367'
  },
  noTerminateLockScreen: {
    CbUnsupported: true,
    fromCcVersion: '25.0.0.3368'
  },
  newUI25: {
    fromCbVersion: '3.1.1439',
    toCbVersion: '3.1.1446',
    CcUnsupported: true
  },
  wideBackground: {
    fromCbVersion: '3.1.1444',
    CcUnsupported: true
  },
  legacyOverlay : {
    fromCbVersion: '3.1.1446',
    CcUnsupported: true
  },
  winlockscreenDelay: {
    CbUnsupported: true,
    fromCcVersion: '25.0.0.3372'
  }
};


export enum Feature {
  isCC = 'isCC',
  isCB = 'isCB',
  Test = 'test',
  CbTest = 'CbTest',
  GPS = 'GPS',
  AndroidSecurity = 'AndroidSecurity',
  WinSecurity = 'WinSecurity',
  WinUsers = 'WinUsers',
  NoAppsInBlockTime = 'NoAppsInBlockTime',
  Screenshots = 'Screenshots',
  ScreenshotsV2 = 'ScreenshotsV2',
  cb3background = 'cb3background',
  protectSettings = 'protectSettings',
  onesecinterval = 'onesecinterval',
  roamingv2 = 'roamingv2',
  loginlock = 'loginlock',
  crackProtection = 'crackProtection',
  bonus = 'bonus',
  addBonusTAN = 'addBonusTAN',
  bonusMax = 'bonusMax',
  noDeleteExtension = 'noDeleteExtension',
  permissionButton = 'permissionButton',
  noBonusNotification = 'noBonusNotification',
  pause = 'pause',
  noBlockNotification = 'noBlockNotification',
  misc20201 = 'misc20201',
  noBlockDualScreen = 'noBlockDualScreen',
  dayChart = 'dayChart',
  alwaysBlockNotification = 'alwaysBlockNotification',
  alwaysPlusBlocktimes = 'alwaysPlusBlocktimes',
  disablePopup = 'disablePopup',
  noAudioStop = 'noAudioStop',
  alwaysAllowedWeb = 'alwaysAllowedWeb',
  hasWebGroups = 'hasWebGroups',
  generalBeepValue = 'generalBeepValue',
  checkUrlFallBack = 'checkUrlFallback',
  customBlockMsg = 'customBlockMsg',
  compatibilityMode = 'compatibilityMode',
  noExtensionDeleteAuto = 'noExtensionDeleteAuto',
  warnAsToast = 'warnAsToast',
  websiteGroups = 'websiteGroups',
  overrideSettings = 'overrideSettings',
  webfilter = 'webfilter',
  manipulationDuration = 'manipulationDuration',
  notificationBlockLevel = 'notificationBlockLevel',
  noAllowedPlusInPause = 'noAllowedPlusInPause',
  keywordsSearchOnly = 'keywordsSearchOnly',
  totalLocalTime = 'totalLocalTime',
  missingNotificationRight = 'missingNotificationRight',
  ccStandardIcon = 'ccStandardIcon',
  bonusPosition = 'bonusPosition',
  fixPortraitBlock = 'fixPortraitBlock',
  manualTimes = 'manualTimes',
  notificationAccess = 'notificationAccess',
  audioOverride = 'audioOverride',
  hasSamsec = 'hasSamsec',
  timecountv2 = 'timecountv2',
  hideViewLimitsReports = 'hideViewLimitsReports',
  countAlwaysExe = 'countAlwaysExe',
  extensionRequest = 'extensionRequest',
  samsecMultiUser = 'samsecMultiUser',
  hidePasswordForgotten = 'hidePasswordForgotten',
  webFilterAllApps = 'webFilterAllApps',
  remainingInfoDetails = 'remainingInfoDetails',
  disableSplitAndCb3Counting = 'disableSplitAndCb3Counting',
  hideUnblockRequest = 'hideUnblockRequest',
  samsecpinapp = 'sameSecPinApp',
  appCheckLevel = 'appCheckLevel',
  skipTotalBySpecialApps = 'skipTotalBySpecialApps',
  tanOffline = 'tanOffline',
  webfilterLevel = 'webfilterLevel',
  noAllowedPlusInPauseCB = 'noAllowedPlusInPauseCB',
  playRingtone = 'playRingtone',
  samsecDisableApps = 'samsecDisableApps',
  blockExtensionApp = 'blockExtensionApp',
  androidSoundLimit = 'androidSoundLimit',
  blockExtensionAppCC = 'blockExtensionAppCC',
  noAudioStopV2 = 'noAudioStopV2',
  webSafeSearch = 'webSafeSearch',
  noTerminateLockScreen = 'noTerminateLockScreen',
  newUI25 = 'newUI25',
  wideBackground = 'wideBackground',
  legacyOverlay = 'legacyOverlay',
  winlockscreenDelay = 'winlockscreenDelay'
}

/**
 * Determines the Child Control and OS versions that support a feature.
 * The version constraints always represent the first version supporting/not supporting the feature.
 *
 * If a constraint is not given, we assume that the platform is supported (e.g. cbUnsupported not given => CB is supported).
 */
export interface FeatureConstraints {
  ChromeOSUnsupported?: boolean;
  CbUnsupported?: boolean;
  /**
   * First CB version that supports the feature
   */
  fromCbVersion?: string;
  /**
   * First CB version that no longer supports the feature
   */
  toCbVersion?: string;
  /**
   * First Android version that supports the feature
   */
  fromAndroidVersion?: string;
  /**
   * First Android version that no longer supports the feature
   */
  toAndroidVersion?: string;

  CcUnsupported?: boolean;
  /**
   * First CC version that supports the feature
   */
  fromCcVersion?: string;
  /**
   * First CC version that no longer supports the feature
   */
  toCcVersion?: string;
  /**
   * First Windows version that supports the feature
   */
  fromWindowsVersion?: string;
  /**
   * First Windows version that no longer supports the feature
   */
  toWindowsVersion?: string;

  // Preparations that can be further developed if we need to handle complex constraints
  /**
   * Allows to define custom constraints that determine when the feature is supported.
   * Other given variables like `fromVersion` are also checked if this function is given.
   * @returns True if feature is supported
   */
  // customCompatibilityCheck?: (device: Device, version: string) => boolean;
}
